'use client';
import React from 'react';
import CurveContainer from '@elements/curve-container';
import Div from '@pezeshk-book/ui-kit/div';
import Text from '@pezeshk-book/ui-kit/text';
import PostComment from '../post-comment';
import useSWR from 'swr';
import postFetchCommentsListApi from '@api/posts/post-get-item-comments';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';
import dictionaryParser from '@utils/helpers/dictionary-parser';
import { LocaleTypes } from '@dictionaries-types';

const Comments = ({ comments, routeKey } : {comments: any, routeKey: string}) => {
  const { lang } = useParams<{lang: LocaleTypes}>();
  const { posts } = getDictionary(lang);
  const response = async () => {
    if (routeKey) {
      return await postFetchCommentsListApi({ id: routeKey, page: 1, cache: 'no-cache' });
    }
  };
  const { data, error } = useSWR(`api/client/v1/posts/${routeKey}/comments`, response, {
    fallback: {
      [`api/client/v1/posts/${routeKey}/comments`]: comments,
    },
  });
  if (error || !routeKey) {
    return null;
  }
  return (
    <CurveContainer>
      <Div id={'comment-section'} className={'flex-col w-full'}>
        <Text align={'center'} typography={'xl'} className={'flex self-center'}>
          {posts.details.comments.title}
        </Text>
        <Text className={'pb-12'} typography={'lg'} color={'tertiary'}>
          {data?.data?.total > 0 ? dictionaryParser({ content: posts.details.comments.comment_count, variables: [{ total: data?.data?.total }] }) : posts.details.comments.no_comment}
        </Text>
        <PostComment
          currentPage={data?.data?.current_page}
          lastPage={data?.data?.last_page}
          list={data?.data?.data}
          postId={routeKey}
        />
      </Div>
    </CurveContainer>
  );
};

export default Comments;
